// extracted by mini-css-extract-plugin
export default {"container":"OnBoardingPageA_container__OfBns","containerText":"OnBoardingPageA_containerText__B8hhU","animation":"OnBoardingPageA_animation__gbObC"};